import PropTypes from "prop-types";
import React, { useRef } from "react";
import styled, { css } from "styled-components";
import Text from "./Text";
import useDialogA11y from "../../hooks/useDialogA11y";

const Content = styled.div`
  background-color: ${({ theme }) => theme.colors.modalColor};
  border-radius: 5px;
  max-width: 360px;
  transition: transform 0.3s ease-out;
  z-index: 9999;
`;

const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.8);
  bottom: 0;
  dsplay: flex;
  left: 0;
  opacity: 0;
  position: fixed;
  right: 0;
  top: 0;
  transition: all 0.3s;
`;

const Wrapper = styled.div`
  align-items: center;
  bottom: 0;
  dsplay: flex;
  justify-content: center;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: fixed;
  right: 0;
  top: 0;
  transition: all 0.3s;
  visibility: hidden;
  z-index: 9;

  ${Content} {
    transform: translate(0, -50px);
  }

  ${({ isOpen }) =>
    isOpen &&
    css`
      display: flex;
      opacity: 1;
      pointer-events: auto;
      visibility: visible;

      ${Content} {
        transform: translate(0, 0);
      }

      ${Overlay} {
        opacity: 1;
      }
    `}
`;

const HeaderWrapper = styled.div`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.outlineColor};
  display: flex;
  justify-content: center;
  padding: 20px;
`;

const Body = styled.div`
  padding: 15px;
  position: relative;
`;

const Footer = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 15px 15px 15px;
`;

const Header = ({ children, ...props }) => {
  return (
    <HeaderWrapper {...props}>
      <Text style={{ color: "black" }} align="center">
        {children}
      </Text>
    </HeaderWrapper>
  );
};

const Modal = ({ children, isOpen, toggle, "aria-label": ariaLabel }) => {
  const dialogRef = useRef(null);
  useDialogA11y(dialogRef, toggle);

  return (
    <Wrapper isOpen={isOpen}>
      <Overlay onClick={toggle} aria-hidden="true" />
      <Content ref={dialogRef} role="dialog" aria-modal="true" aria-label={ariaLabel || "Dialog"}>
        {children}
      </Content>
    </Wrapper>
  );
};

Modal.Header = Header;
Modal.Body = Body;
Modal.Footer = Footer;

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default Modal;
